<template>
    <v-card
        tile
        flat
        class="balanceCard"
        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-sheet
                        class="d-flex mb-0"
                        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                    >
                        <div class="title">
                            <v-icon dense color="#5F7692"
                                >mdi-bag-checked</v-icon
                            >
                            <span class="ml-2">Balance</span>
                            <p class="number mb-0 text--green">
                                {{ mt5AccountDetails?.Balance?.toFixed(2) }}
                                <strong>USD</strong>
                            </p>
                        </div>
                    </v-sheet>
                </v-col>
                <v-col cols="12">
                    <v-card-text
                        class="d-flex pl-3 pb-2 mt-4 pr-0 trade align-center"
                    >
                        <p class="equity">
                            <span class="mb-2 d-inline-block">Acc. Type:</span>
                            {{
                                mt5AccountDetails?.tradingaccounttypes
                                    ?.account_type_display
                            }}
                            <br />
                            <span class="mb-2 d-inline-block">Credit:</span> $
                            {{ mt5AccountDetails?.Credit?.toFixed(2) }}<br />
                            <span class="mb-2 d-inline-block">Equity:</span>
                            {{ mt5AccountDetails?.Equity?.toFixed(2) }}
                        </p>
                        <v-spacer></v-spacer>
                        <p class="equity text-right">
                            <span class="mb-2 d-inline-block">Mt5 Currency:</span>
                            {{ mt5AccountDetails?.currency_name }}<br />
                            <span class="mb-2 d-inline-block">Leverage:</span> 1
                            : {{ mt5AccountDetails?.leverage }} <br />
                        </p>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState("trading", ["mt5AccountDetails"]),
    },
    methods: {
        ...mapActions("trading", [TRADING__ACTIONS.MT5ACCOUNTDETAILS]),
    },
    async mounted() {
        await this[TRADING__ACTIONS.MT5ACCOUNTDETAILS](this.$route.query.id);
    },
};
</script>
